<template>
    <el-select v-model="selectValue" placeholder="请选择" clearable filterable @change="changed" @clear="cleard"
        :disabled="disabled">
        <el-option v-for="item in options" :key="item.optionValue" :label="item.optionText" :value="item.optionValue">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        props: ["url", "value", "defaultChooseFirst", "bindDisabled"],
        data() {
            return {
                options: [],
                selectValue: this.value,
                // bindDisabled:this.bindDisabled,
                disabled: false,
            };
        },
        methods: {
            changed() {
                this.emitOptionChanged();
            },
            cleard() {
                this.emitOptionChanged();
            },
            emitOptionChanged() {
                this.$emit("optionChanged", {
                    url: this.url,
                    value: this.selectValue
                });
            }
        },
        created() {
            var a = String(this.value).trim() == '' || undefined ? false : (this.bindDisabled == null ? false : this
                .bindDisabled)
            this.disabled = a;
            this.$ajaxGet(this.url, data => {
                this.options = data.result;
                if (this.defaultChooseFirst && this.options.length > 0 && !this.value) {
                    this.selectValue = this.options[0].optionValue;
                    this.emitOptionChanged();
                }
            });
        }
    };
</script>
